import { render, staticRenderFns } from "./MoqAlertModal.vue?vue&type=template&id=20901f84&scoped=true&lang=pug"
import script from "./MoqAlertModal.vue?vue&type=script&lang=js"
export * from "./MoqAlertModal.vue?vue&type=script&lang=js"
import style0 from "./MoqAlertModal.vue?vue&type=style&index=0&id=20901f84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20901f84",
  null
  
)

export default component.exports